import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  dispatchLanguage,
  returnHome,
  updateProfileLanguage,
} from "../../../Redux/ActionCreator";
import {
  saveIntoServerCache,
  getOneFromServerCache,
} from "../../../utils/saveIntoCache";
import { capitalize } from "../../../utils/capitalize/capitalizeWord";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";

const EditLanguage = ({ handleClick }) => {
  const dispatch = useDispatch();
  const language_data = useSelector((lan) => lan.language);
  const profile1 = useSelector((e) => e.login);
  const userInfo = useSelector((e) => e.userInfo);
  let stat = profile1.profile_status.profile_status;
  const secret = useSelector((prev) => prev.secret);
  const lang_data = useSelector((lan) => lan.lang);
  const flowLanguage = useSelector((e) => e.t_lang.selected);
  const p_profile = useSelector((e) => e.profile);

  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [customLanguage, setCustomLanguage] = useState(null);

  const proficiencyLevels = ["Beginner", "Intermediate", "Fluent", "Native"];

  const [languages, setLanguages] = useState([
    // { language: "English", rate: "" },
    // { language: "Deutsch", rate: "" },
    // { language: "Hausa", rate: "" },
    // { language: "Kanuri", rate: "" },
  ]);

  const handleLevelChange = (index, level) => {
    setLanguages((prev) =>
      prev.map((lang, i) => (i === index ? { ...lang, rate: level } : lang))
    );
  };

  const handleSelctedLangLevelChange = (index, level) => {
    setSelectedLanguages((prev) =>
      prev.map((lang, i) => (i === index ? { ...lang, rate: level } : lang))
    );
  };

  const handleCustomLanguageChange = (event) => {
    setCustomLanguage({ language: capitalize(event.target.value), rate: "" });
  };

  const handleAddCustomLanguage = () => {
    if (customLanguage) {
      // console.log(selectedLanguages)
      setSelectedLanguages([
        ...new Set([...selectedLanguages, customLanguage]),
      ]);
      dispatch(dispatchLanguage(selectedLanguages));
      setCustomLanguage({ language: "", rate: "" });
    }
  };

  useEffect(() => {
    dispatch(dispatchLanguage(languages));
    // save into server cache
    let saveToCache = async () => {
      await saveIntoServerCache("language", languages);
    };
    saveToCache();
  }, [languages]);

  useEffect(() => {
    if (!window.location.pathname.includes("/user/profile")) {
      if (language_data.lang !== null && language_data.lang !== undefined) {
        setLanguages(language_data?.lang);
      } else {
        let cacheInfo = getOneFromServerCache("language");
        cacheInfo
          .then((res) => res.json())
          .then((res) => {
            // console.log("server cache value", res);
            if (res.success == true) {
              let resObj = JSON.parse(res.data);
              // console.log("language respObj", resObj);
              if (resObj !== null && resObj !== undefined) {
                dispatch(dispatchLanguage(resObj));
                setLanguages(resObj);
              }
              // console.log("Done");
            } else if (res.success === false && res.message == "Unauthorized") {
              dispatch(returnHome(res.status));
            }
          });
      }
    } else if (window.location.pathname.includes("/user/profile")) {
      if (p_profile.message !== null) {
        setLanguages(p_profile.message?.Language);
      }
    }
  }, []);

  const handleSaveCall = () => {
    try {
      if (languages.length !== 0 || selectedLanguages.length !== 0) {
        let combined_lang = [...new Set([...languages, ...selectedLanguages])];
        dispatch(dispatchLanguage(combined_lang));
        if (
          (p_profile.message !== null &&
            (p_profile.message?.Language == null ||
              p_profile.message?.Language == undefined ||
              window.location.pathname.includes("/user/profile"))) ||
          window.location.pathname.includes("jobs")
        ) {
          dispatch(updateProfileLanguage(selectedLanguages));
        }
        handleClick();
      } else {
        setTimeout(() => {
          toast.error("At least one language is required", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
      }
    } catch (error) {
      throw error;
    }
  };

  const handleDelete = (element) => {
    let newLang = languages?.filter((e) => e.language !== element.language);
    setLanguages(newLang);
    let newSelectedLang = selectedLanguages?.filter(
      (e) => e.language !== element.language
    );
    setSelectedLanguages(newSelectedLang);
  };

  return (
    <div className="bg-transparent px-4 md:px-6 lg:px-8 xl:px-10 py-8 sm:w-[100vw] vsm:w-[100vw] flex justify-center rounded-xl my-6 max-h-[90vh]">
      <div className="sm:w-[100vw] vsm:w-[100vw] gap-y-2 lg:gap-0 lg:h-full flex flex-col lg:justify-between justify-center rounded-lg p-6 md:p-8 h-full bg-white">
        <div className="text-center mb-4 text-[#5843BD] font-semibold">
          Edit Language
        </div>
        <p className="text-center mb-6">
          What languages do you speak? (You can select more than one)
        </p>

        <div className="flex flex-col gap-6 w-full max-w-[500px] mx-auto mb-4">
          {languages?.map((language, index) => (
            <div className="md:flex items-center gap-4 w-full">
              {/* Only show the current dropdown if the previous one is filled */}
              {(index === 0 || languages[index - 1].rate !== "") && (
                <>
                  <div className="px-4 py-2 bg-black text-white rounded-md min-w-[100px] text-center vsm:my-4 my-0">
                    {language.language}
                  </div>

                  <div className="flex items-center gap-4 w-full">
                    <FormControl
                      fullWidth
                      sx={{
                        // Style the outer input border:
                        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                          {
                            borderColor: "orange",
                          },
                        // When focused:
                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                          {
                            borderColor: "orange",
                          },
                      }}
                    >
                      <InputLabel>Select your proficiency level</InputLabel>
                      <Select
                        value={language.rate}
                        onChange={(e) =>
                          handleLevelChange(index, e.target.value)
                        }
                        sx={{
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#FF6633",
                          },
                        }}
                      >
                        {proficiencyLevels.map((level, idx) => (
                          <MenuItem
                            key={idx}
                            value={level}
                            sx={{
                              "&:hover": {
                                backgroundColor: "#FF6633",
                                color: "#fff",
                              },
                            }}
                          >
                            {level}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    className="flex items-center justify-center py-3 px-3 border border-[#777DEA54] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent cursor-pointer mr-2 rounded-lg lg:w-[200px] vsm:w-full vsm:my-2 md:my-0"
                    onClick={() => handleDelete(language)}
                  >
                    Delete
                  </div>
                </>
              )}
            </div>
          ))}
        </div>

        <p className="text-black text-center font-medium text-sm mb-2">
          Can't find your language on the list? Type it in the box below and
          click "Add language"
        </p>
        <div className="flex vsm:flex-wrap items-center justify-center">
          <input
            type="text"
            className="w-full max-w-[400px] border-2 border-orange-500 rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent md:mr-2"
            placeholder="type your language here"
            value={customLanguage?.language}
            onChange={handleCustomLanguageChange}
          />
          <button
            className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-4 rounded-lg vsm:my-4 my-0 vsm:w-full md:w-auto border-2 max-w-[400px]"
            onClick={handleAddCustomLanguage}
          >
            + Add language
          </button>
        </div>

        <div className="pb-4">
          <p className="font-bold text-center my-4">You have added:</p>
          <div className="flex flex-wrap item-center justify-center gap-2">
            {selectedLanguages?.map((language, index) => (
              <div className="md:flex justify-center items-center gap-4 vsm:w-full ">
                {/* Only show the current dropdown if the previous one is filled */}
                {(index === 0 || languages[index - 1]?.rate !== "") && (
                  <>
                    <div className="px-4 py-2 bg-black text-white rounded-md min-w-[100px] text-center vsm:my-4 my-0">
                      {language.language}
                    </div>

                    <div className="flex items-center gap-4 md:w-[400px] vsm:w-full">
                      <FormControl
                        fullWidth
                        sx={{
                          // Style the outer input border:
                          "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor: "orange",
                            },
                          // When focused:
                          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              borderColor: "orange",
                            },
                        }}
                      >
                        <InputLabel>Select your proficiency level</InputLabel>
                        <Select
                          value={language?.rate}
                          onChange={(e) =>
                            handleSelctedLangLevelChange(index, e.target.value)
                          }
                          sx={{
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#FF6633",
                            },
                          }}
                        >
                          {proficiencyLevels.map((level, idx) => (
                            <MenuItem
                              key={idx}
                              value={level}
                              sx={{
                                "&:hover": {
                                  backgroundColor: "#FF6633",
                                  color: "#fff",
                                },
                              }}
                            >
                              {level}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center my-2">
          <div className="flex justify-between lg:max-w-[90vw] w-full">
            <button
              onClick={handleClick}
              className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 px-4 rounded-md"
            >
              <span className="notranslate" key={flowLanguage}>
                {flowLanguage == "Spanish" ? "Cancelar" : "CANCEL"}
              </span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="24" height="24" rx="12" fill="#FF6633" />
                <path
                  d="M15.1893 18C15.1132 18 15.0412 17.9653 14.9938 17.9058L12.0561 14.2175C11.953 14.0881 11.7548 14.0927 11.6579 14.2269L9.00599 17.8964C8.95899 17.9615 8.88362 18 8.80337 18H6.07388C5.86606 18 5.74897 17.7612 5.87625 17.5969L10.132 12.1039C10.2027 12.0127 10.2017 11.8849 10.1297 11.7948L5.82441 6.40605C5.69361 6.24233 5.81018 6 6.01973 6H8.81098C8.88693 6 8.95877 6.03453 9.00621 6.09384L11.9435 9.76586C12.0469 9.89503 12.2449 9.89004 12.3416 9.75583L14.9727 6.10386C15.0197 6.03865 15.0952 6 15.1756 6H17.9053C18.1131 6 18.2302 6.23864 18.1031 6.40295L13.8676 11.8792C13.7971 11.9703 13.798 12.0978 13.8698 12.1879L18.1767 17.5942C18.3072 17.758 18.1906 18 17.9812 18H15.1893Z"
                  fill="white"
                />
              </svg>
            </button>
            <button
              onClick={handleSaveCall}
              className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md"
            >
              <span className="notranslate" key={flowLanguage}>
                {flowLanguage == "Spanish" ? "GUARDAR" : "SAVE"}
              </span>
              <svg
                width="11"
                height="18"
                viewBox="0 0 11 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.5 8.99891L1.5 16.3789"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.5 9L1.5 1.62"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default EditLanguage;
